enum AccountCategory {
  CREDIT_CARD = 'CREDITCARD',
  DEPOSIT = 'DEPOSIT',
  LOAN = 'LOAN',
  UNSECUREDLOAN = 'UNSECUREDLOAN',
  OTHER = 'OTHER',
  // As of now we do not support/use external account categories
  EXTERNAL_CONSUMPTION = 'EXTERNAL_CONSUMPTION',
  EXTERNAL_CARD = 'EXTERNAL_CARD',
  EXTERNAL_LOAN = 'EXTERNAL_LOAN',
  EXTERNAL_LOCKED_SAVINGS = 'EXTERNAL_LOCKED_SAVINGS',
  EXTERNAL_OPEN_SAVINGS = 'EXTERNAL_OPEN_SAVINGS',
  EXTERNAL_UNKNOWN = 'EXTERNAL_UNKNOWN',
}

export default AccountCategory;
